// extracted by mini-css-extract-plugin
export default {"merchantLogo":"MerchantLogo_merchantLogo__cyrjt","merchantLogoPlaceholder":"MerchantLogo_merchantLogoPlaceholder__LXkzQ"};